export default __webpack_public_path__ + "static/media/CarWash2.ee8ecea7.jpg";